import type { PageLoad } from './$types';
import { redirect } from '@sveltejs/kit';
import { getPage, getPreviewHeader } from '$lib/util/pagebuilder';
import { handleRedirect } from '$lib/util/redirects';

export const load: PageLoad = async ({ parent, params, url }) => {
	const p = await parent();

	const { path, lang } = params;

	if (path === 'home') {
		redirect(302, '/' + lang + '' + url.search);
	}

	handleRedirect(path, p.redirects)

	const previewHeader = getPreviewHeader(p.previewToken);

	const page = await getPage(params, { data: p }, previewHeader)

	return {
		page
	};
};
